var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCvLess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fb3640;}.b{fill:#0b132b;font-size:10px;font-family:Poppins-Bold, Poppins;font-weight:700;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-930 -1428.338)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.5,3A11.5,11.5,0,1,1,3,14.5,11.5,11.5,0,0,1,14.5,3Zm9.2,11.5a9.2,9.2,0,0,0-9.2-9.2A9.088,9.088,0,0,0,8.865,7.243L21.757,20.135A9.088,9.088,0,0,0,23.7,14.5Zm-9.2,9.2a9.088,9.088,0,0,0,5.635-1.944L7.244,8.865A9.088,9.088,0,0,0,5.3,14.5,9.2,9.2,0,0,0,14.5,23.7Z",
    transform: "translate(927 1425.338)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(934 1444)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CV")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvLess);
export default __webpack_public_path__ + "static/media/cv_less.0273b10587d65bf9ae82f57c0e159539.svg";
export { ForwardRef as ReactComponent };